import { render, staticRenderFns } from "./userSuccess.vue?vue&type=template&id=6c26002e&scoped=true&"
import script from "./userSuccess.vue?vue&type=script&lang=js&"
export * from "./userSuccess.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c26002e",
  null
  
)

export default component.exports